import { api } from '../helpers';

export const create = (payload, token) => {
	return api('/Feedback/CreateFeedback', 'POST', payload, null, token);
};
